import React, {Component} from "react";
import PropTypes from "prop-types";
import Octicon, {ChevronLeft, ChevronRight} from "@github/octicons-react/dist/index.umd";
import WeekMode from "../enums/weekMode";

export default class WeekSwitcher extends Component {
    nextWeek = () => {
        let nextIndex = this.getCurrentIndex() + 1;

        if(nextIndex === this.props.weekNumbers.length) {
            return;
        }

        this.props.onCurrentWeekChanged(this.props.weekNumbers[nextIndex]);
    };

    previousWeek = () => {
        let nextIndex = this.getCurrentIndex() - 1;

        if(nextIndex < 0) {
            return;
        }

        this.props.onCurrentWeekChanged(this.props.weekNumbers[nextIndex]);
    };

    changeWeekMode = () => {
        let weekMode = this.props.weekMode === WeekMode.WorkWeek ? WeekMode.WholeWeek : WeekMode.WorkWeek;
        this.props.onWeekModeChanged(weekMode);
    };

    getCurrentIndex() {
        return this.props.weekNumbers.indexOf(this.props.currentWeek);
    }

    render() {
        let weekModeText = this.props.weekMode === WeekMode.WholeWeek ? 'Arbeitswoche' : 'Ganze Woche';

        return (
            <div className="btn-group mx-3" role="group">
                <button type="button" className="btn btn-outline-light" onClick={() => this.previousWeek()}><Octicon icon={ChevronLeft}/> vorherige Woche</button>
                <button type="button" className="btn btn-outline-light" onClick={() => this.changeWeekMode()}>{weekModeText}</button>
                <button type="button" className="btn btn-outline-light" onClick={() => this.nextWeek()}>nächste Woche <Octicon icon={ChevronRight}/></button>
            </div>
        )
    }
}

WeekSwitcher.propTypes = {
    weekNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,
    weekMode: PropTypes.instanceOf(WeekMode).isRequired,
    currentWeek: PropTypes.number.isRequired,
    onWeekModeChanged: PropTypes.func.isRequired,
    onCurrentWeekChanged: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/WeekSwitcher.js